import React from 'react';
import { Breadcrumb, BreadcrumbItem, Button, ButtonGroup, Card, CardBody, CardHeader, Media } from 'reactstrap';
import { Link } from 'react-router-dom';
import Iframe from './Iframe';
function Biography (props) {  
 
        
    return (
        <div class="container-fluid">
             <div className="row">
                <div className="col">
                    <Breadcrumb>
                        <BreadcrumbItem><Link to="/home">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Biography</BreadcrumbItem>
                    </Breadcrumb>
                
                    <hr />
                </div>
            </div>


        <div class="row pt-25 top-buffer">
            <div class="col-sm-1"></div>
            <div class="col-sm-5 pb-20" >
                <h3 style={{color: '#700000'}}>Personal Qualities</h3>
                <img src="http://charlessuits.org/sites/MrSuits.net/charlessuits/img/chuck.jpg" width="100px" class="TextWrap" />
                <p>
                    
                    I have been married for 45 years with five children. I enjoy films, travel and working out at the gym.
                    I'm innovative, inspired communicator, 'out of the box' thinker, motivator and life- long learner.
                    I feel driven in this lifetime to see as many new places as possible and to help those I meet along
                    the way. Whether it is a store clerk or a student, I take the time to listen and guide them on a
                    path to improve their lives. After graduating from college, I immersed myself in the world of
                    computers because I thought that technology would help make people's lives easier and therefore
                    better.
                </p>

                <p>However, after twenty years in the computer software business, I found myself disillusioned. So at
                    the age of almost 40 years, I decided to go to law school. I had five children at the time too.
                </p>

                <p>As a lawyer, I felt that I could help others maneuver >their way through the system to improve their
                    daily lives. I could be a champion for the troubled and lost souls. I was able to help the poor in
                    Washington D.C. as a major crimes investigator for the Public Defender's Office. I walked the
                    streets at night looking over my shoulder and sat through many sad trials.
                </p>

                <p>I graduated and ended up working in a glass office next to the Watergate Building. I have some
                    stories to tell, but most are about helping corporations avoid the law to make more money. What
                    happened to my desire to see new places and help others along the way?
                </p>

                <p>This desire led to teaching at an American university in Europe. I thrived on giving career advice,
                    recruiting students, and teaching classes that I created ranging from Negotiations to Cross-Cultural
                    Behavior. I organized Friday Film Nights and showed my favorite interesting movies to the students.
                    I dreamed up a Cultural Immersion Program of art, history, and music classes that came true. The MBA
                    Program grew in record breaking numbers under my guidance. Then I had the opportunity to teach some
                    computer classes at a nearby international high school.
                </p>

                <p>The next thing I knew I was giving college advice to teens and helping them through their computer
                    studies. I also subbed in middle school and then elementary school. This was fun and rewarding at
                    the same time. Now why didn't I get my teaching certificate in college? Now was the time. Having a
                    certificate has opened up doors of opportunity for me to help others and see new places along the
                    way. Students have told me that I am a good listener and communicator. Hmmm, maybe I should get a
                    counseling degree next.
                </p>

                <img src="http://charlessuits.org/sites/MrSuits.net/charlessuits/img/family.jfif" width="100%" />
            </div>

            <div class="col-sm-5 pb-20" >
                <h3 style={{color: '#700000'}}>Narrative</h3>
                <p>Question: <b>What makes you an outstanding educator?</b></p>

                <p>When I entered the Middle School Social Studies class, the students raised their heads and looked
                    curiously at me. They listened politely as I introduced myself. Then they started chattering in Thai
                    to each other, sending text messages on their phones and turning their backs to me. I needed to do
                    something fast to gain their attention. So I picked up three objects off my desk and started
                    juggling. They stopped and looked at me with suspicion. What was that 'farang' teacher doing? I
                    offered to teach them how to juggle and told them they could earn their own set of juggling balls if
                    they could juggle for ten times in a row. This caught their interest and became a year long
                    challenge to the students.
                </p>

                <p>After reaching out across the language and cultural barriers, I was able to grab their attention in
                    academic ways. During the unit on Ancient History, I organized the class into small groups. Then I
                    modeled how to create a Wikispace on the Internet. Each group chose a different area of the time in
                    history to show their learning on their Wikispace. I told them that they would have a real audience
                    of third graders from another international school to evaluate their Wikispaces. They researched in
                    books, articles and the Internet for information. Then they hunted for graphics that would accompany
                    the text they wrote. Finally, the students had to make it understandable and appealing to third
                    graders.
                </p>

                <p>The class was finally ready to download their Wikispaces to a site where the third graders on the
                    other side of town could view them. The third graders completed an evaluation checklist for the
                    different aspects of the Wikispace and information. The third graders were excited to take on the
                    role of the teacher in evaluation. When the evaluation forms were returned to the middle schoolers,
                    they focused on the comments and scoring. They discovered that the most graphic, flashy sites got
                    the highest ratings. It was an authentic assignment with a real life audience that captured their
                    attention.
                </p>

                 <p>I believe learning starts with questions and engages students who want to find the answers. Self
                    motivated students evolve when they ask the questions. That is my goal as an educator to engage
                    students in the learning process. As a teacher, I am the 'Guide by the Side.' I am there to lend
                    support and ideas that will help the student on their way. By focusing constantly on student
                    learning, the process develops effortlessly into innovative displays of knowledge. As an educator
                    and student myself, I am always learning with my students.
                </p>

                <p>Question: <b>Please describe yourself personally and professionally with qualifications and experience
                    that will enable you to be successful in an multi-cultural school?</b>
                </p>

                <p>I love to help people. During my whole career, there is one consistent theme of being in a position
                    where I am able to help others. I am an innovative leader who uses the latest technology to improve
                    student and teacher learning. I have 25 years experience working overseas. I am an 'out of the box'
                    thinker who will find useful ways to apply ideas to real world problems with positive results.
                </p>


                <p>As Director of IT and ICT Coordinator for over six years, I have worked with both staff and
                    students to integrate technology across the curriculum. At the International School Florence, Italy,
                    Uruguayan American School, and the American International School of Jeddah, Saudi Arabia, I
                    implemented Google Apps Technology. I introduced a new IT Curriculum and "paperless" teaching method
                    into the ICT core courses. Each class has their own website for content, assignments and
                    communication. Students in grades 6-12 create their own websites to show what they have learned. In
                    addition, I taught IB Information Technology in the Global Society (IB ITGS) and served as the MAP
                    Testing Technical Coordinator.
                </p>


                <p>Previously I planned an international school of the future in Songdo, South Korea. As Director of
                    Educational Technology, I guided the implementation of Google Apps as a means of sharing documents,
                    e-mail and creating a website for the new school. I also used my background of over 20 years in the
                    computer software business to research and select computers for our office and a tablet for our
                    students.
                </p>


                <p>I believe in the Socratic Method and am constantly asking questions. I believe that knowledge and
                    learning lie in finding the right questions to ask. I have earned a Bachelor, Masters, and Doctorate
                    degree and taught over 70 courses in over 20 different subjects. I read about new technologies daily
                    and try out the latest technology tools. I believe that my technical background compliments my
                    social skills.
                </p>


                <p>Ask anyone I have worked with and they will confirm that I am a communicator. I am honest and can
                    get to the point of the matter quickly. I evaluate and consider all sides before making a decision.
                    I collaborate with my colleagues in order to create better ways to educate students. I am open to
                    new possibilities and pathways. These personality traits combined with my overseas experiences make
                    me an excellent candidate for a position at an international school.
                </p>
            </div>
        </div>
    </div>
    );
}
export default Biography
